import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/2a2ba5ce/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
import { Grid } from 'theme-ui';
import { Link } from '@undataforum/components';
import ContinuityIcon from '../icons/continuity-icon';
import DataSolutionsIcon from '../icons/data-solutions-icon';
import OpenDataIcon from '../icons/open-data-icon';
import SharingIcon from '../icons/sharing-icon';
import WebLinksIcon from '../icons/web-links-icon';
import WorkRemotelyIcon from '../icons/work-remotely-icon';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Gatsby`}</h2>
    <p>{`This website is built with `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`Gatsby`}</a>{`, a free and open
source framework based on React that helps developers build blazing fast
websites and apps.`}</p>
    <h2>{`GitHub`}</h2>
    <p>{`The source code of this website is hosted
`}<a parentName="p" {...{
        "href": "https://github.com/UNStats/covid-19-response"
      }}>{`in this GitHub repository`}</a>{`
enabling collaboration during the COVID-19 pandemic and allowing direct conent
and code contributions from the statistical community.`}</p>
    <h2>{`Noun Project`}</h2>
    <p>{`This websites uses the following icons from the
`}<a parentName="p" {...{
        "href": "https://thenounproject.com/"
      }}>{`Noun Project`}</a>{`:`}</p>
    <Grid gap={3} width={64} mb={3} mdxType="Grid">
  <Link href="https://thenounproject.com/browse/?i=2154258" sx={{
        color: 'primary'
      }} mdxType="Link">
    <ContinuityIcon height={64} mdxType="ContinuityIcon" />
  </Link>
  <Link href="https://thenounproject.com/browse/?i=2909082" sx={{
        color: 'primary'
      }} mdxType="Link">
    <WorkRemotelyIcon height={64} mdxType="WorkRemotelyIcon" />
  </Link>
  <Link href="https://thenounproject.com/browse/?i=2223266" sx={{
        color: 'primary'
      }} mdxType="Link">
    <DataSolutionsIcon height={64} mdxType="DataSolutionsIcon" />
  </Link>
  <Link href="https://thenounproject.com/browse/?i=38245" sx={{
        color: 'primary'
      }} mdxType="Link">
    <OpenDataIcon height={64} mdxType="OpenDataIcon" />
  </Link>
  <Link href="https://thenounproject.com/browse/?i=618963" sx={{
        color: 'primary'
      }} mdxType="Link">
    <WebLinksIcon height={64} mdxType="WebLinksIcon" />
  </Link>
  <Link href="https://thenounproject.com/browse/?i=2690278" sx={{
        color: 'primary'
      }} mdxType="Link">
    <SharingIcon height={64} mdxType="SharingIcon" />
  </Link>
    </Grid>
    <h2>{`Vercel`}</h2>
    <p>{`This website is hosted on `}<a parentName="p" {...{
        "href": "https://vercel.com/home"
      }}>{`Vercel Now`}</a>{` and is served
from the `}<a parentName="p" {...{
        "href": "https://vercel.com/edge-network"
      }}>{`Vercel Edge Network`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      